/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./denyTeleport.defs.js";
export { main as default } from "./denyTeleport.defs.js";
